import { useEffect, useState } from 'react';

import { ERC20_ABI, RAFFLE_ABI, RAFFLE_ADDRESS } from '../services/contracts';
import { readMulticall } from '../services/read-function';
import { PublicClient } from 'viem';

export function useRestoreAllowance(
  publicClient: PublicClient | null,
  owner: `0x${string}` | undefined,
) {
  const [needsAllowance, setNeedsAllowance] = useState<boolean>(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    async function check() {
      if (!publicClient || !owner) return;
      try {
        setLoading(true);
        let tokenAddr: `0x${string}`;
        try {
          tokenAddr = (await publicClient.readContract({
            address: RAFFLE_ADDRESS,
            abi: RAFFLE_ABI,
            functionName: 'token',
            authorizationList: undefined,
          })) as `0x${string}`;
        } catch {}

        const calls = [
          { address: RAFFLE_ADDRESS, abi: RAFFLE_ABI, functionName: 'recoveryAmount' },
          {
            address: tokenAddr,
            abi: ERC20_ABI,
            functionName: 'allowance',
            args: [owner, RAFFLE_ADDRESS],
          },
        ];

        const [neededRes, allowanceRes] = await readMulticall(publicClient, calls);
        const needed = neededRes.status === 'success' ? (neededRes.result as bigint) : 0n;
        const allowance = allowanceRes.status === 'success' ? (allowanceRes.result as bigint) : 0n;

        if (!cancelled) {
          setNeedsAllowance(allowance < needed);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    check();
    return () => {
      cancelled = true;
    };
  }, [publicClient, owner]);

  return { needsAllowance, loading };
}
